/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SenderIdColumnFormatter = (cellContent, row, rowIndex) => {
  const { senderId } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {senderId ? senderId : `-`}
      </div>
      <> </>
    </>
  );
};
